import { useUser } from '../contexts/UserContext';
import { PLAN_CODES, PLAN_LABELS, PLAN_RANK, NEXT_PLAN } from './Constants';

/**
 * M3 entitlement helper. Reads the current plan from UserContext and derives the
 * tier rank, whether the user is on a paid plan, and the next tier up (for
 * "Upgrade to X for More" nudges). Anonymous users resolve to FREE.
 */
export default function useEntitlement() {
    const { userState } = useUser();
    const currentPlan = userState?.currentPlan || PLAN_CODES.FREE;
    const planRank = PLAN_RANK[currentPlan] ?? 0;
    const nextPlan = NEXT_PLAN[currentPlan] || null;
    return {
        currentPlan,
        planRank,
        isPaid: planRank > 0,
        isPremium: currentPlan === PLAN_CODES.PREMIUM,
        nextPlan,
        nextPlanLabel: nextPlan ? PLAN_LABELS[nextPlan] || nextPlan : null,
        isLoggedIn: !!userState?.isLoggedIn,
    };
}
